import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'element-react'
import { Field } from 'react-final-form'
import { CustomSelect, TempCustomSelect } from '../../../helpers/fieldHelper'
import { isInternetExplorer } from '../../../helpers/util'

const combinedAddressLabel = (address, label) =>
    address ? label + ' - ' + address : label

const ShiptoDropdown = props => {
    const { label = '', name, shiptos, validate, ...customProps } = props

    return isInternetExplorer() ? (
        <Field
            label={label}
            name={name}
            component={TempCustomSelect}
            options={shiptos.map(shipto => {
                return {
                    key: shipto.value,
                    label: combinedAddressLabel(shipto.address, shipto.label),
                    value: shipto.value,
                    element: (
                        <React.Fragment>
                            <span className="label">{shipto.label}</span>
                            <span className="description">
                                {shipto.address}
                            </span>
                        </React.Fragment>
                    ),
                }
            })}
            placeholder="Select"
            validate={validate}
            {...customProps}
        />
    ) : (
        <Field
            label={label}
            name={name}
            component={CustomSelect}
            options={shiptos.map(shipto => {
                return (
                    <Select.Option
                        className="multi-line"
                        key={shipto.value}
                        label={combinedAddressLabel(
                            shipto.address,
                            shipto.label,
                        )}
                        value={shipto.value}
                    >
                        <span className="label">{shipto.label}</span>
                        <span className="description">{shipto.address}</span>
                    </Select.Option>
                )
            })}
            placeholder="Select"
            {...customProps}
        />
    )
}

ShiptoDropdown.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    shiptos: PropTypes.arrayOf(PropTypes.object).isRequired,
    validate: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
    isRequired: PropTypes.bool,
}

export default ShiptoDropdown
